import { createContext, useContext, useEffect } from "react";

// Theme locked to "d" (Electric Lime / green) — finalised by the client.
const ThemeContext = createContext({ theme: "d" });

export const ThemeProvider = ({ children }) => {
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", "d");
  }, []);
  return <ThemeContext.Provider value={{ theme: "d" }}>{children}</ThemeContext.Provider>;
};

export const useTheme = () => useContext(ThemeContext);
